// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__6Gkh2","img1":"Avatar_img1__HPf3B","img2":"Avatar_img2__Fdpuw"};